import { ChangeLanguagaInput } from './dto/changeLanguageInput';
import { CreateOrUpdateUserInput } from './dto/createOrUpdateUserInput';
import { EntityDto } from '../../services/dto/entityDto';
import { GetAllUserOutput } from './dto/getAllUserOutput';
import { PagedResultDto } from '../../services/dto/pagedResultDto';
import { PagedUserResultRequestDto } from "./dto/PagedUserResultRequestDto";
import { UpdateUserInput } from './dto/updateUserInput';
import http from '../httpService';
import { EntityCommitContainer, FileUpload } from '../dto/fileActionResultDto';
import { UserAskDto } from './dto/userAskDto';
import { ItemDto } from '../dto/entities/itemDto';
import { NoteDto } from '../dto/entities/noteDto';
import { NoteRecordDto } from '../dto/entities/noteRecordDto';
import { OptionDto } from '../dto/entities/optionDto';
import { RecordDto } from '../dto/entities/recordDto';
import { StateDto } from '../dto/entities/stateDto';
import { TemplateDto } from '../dto/entities/templateDto';
import { TypeDto } from '../dto/entities/typeDto';
import { ReturnDto } from '../dto/returnDto';
import { CreateDto } from '../dto/createDto';
import { SummaryReturnDto } from '../dto/summaryReturnDto';
import { EntitySummaryDto } from '../dto/summaries/entitySummaryDto';
import { ItemSummaryDto } from '../dto/summaries/itemSummaryDto';
import { NoteRecordSummaryDto } from '../dto/summaries/noteRecordSummaryDto';
import { NoteSummaryDto } from '../dto/summaries/noteSummaryDto';
import { OptionSummaryDto } from '../dto/summaries/optionSummaryDto';
import { StateSummaryDto } from '../dto/summaries/stateSummaryDto';
import { TemplateSummaryDto } from '../dto/summaries/templateSummaryDto';
import { TypeSummaryDto } from '../dto/summaries/typeSummaryDto';
import { UserListSummaryDto } from '../dto/summaries/userListSummaryDto'; 
import { TemplateRecordDto } from '../dto/records/templateRecordDto';
import { PersonListSummaryDto } from '../dto/summaries/personListSummaryDto';
import { TeamListSummaryDto } from '../dto/summaries/teamListSummaryDto';
import { PeopleAskDto } from '../people/dto/peopleAskDto';
import { PeopleEntitySummaryDto } from '../people/dto/summaries/peopleEntitySummaryDto';
import { PeopleItemSummaryDto } from '../people/dto/summaries/peopleItemSummaryDto';
import { PeopleOptionSummaryDto } from '../people/dto/summaries/peopleOptionSummaryDto';
import { PeopleStateSummaryDto } from '../people/dto/summaries/peopleStateSummaryDto';
import { PeopleSummaryReturnDto } from '../people/dto/summaries/peopleSummaryReturnDto';
import { PeopleTemplateSummaryDto } from '../people/dto/summaries/peopleTemplateSummaryDto';
import { PeopleTypeSummaryDto } from '../people/dto/summaries/peopleTypeSummaryDto';
import { ChangePasswordInput } from './dto/changePasswordInput';
import { ResetPasswordInput } from './dto/resetPasswordInput';
import { InfoHubArticleSummaryDto } from '../infoHub/dto/infoHubArticleSummaryDto'; 
import type { CommunicationListSummaryDto } from '../dto/summaries/communicationListSummaryDto';
import type { InventoryListSummaryDto } from '../dto/summaries/inventoryListSummaryDto';
import type { MenuListSummaryDto } from '../dto/summaries/menuListSummaryDto';
import type { PaymentsListSummaryDto } from '../dto/summaries/paymentsListSummaryDto';
import type { ReportsListSummaryDto } from '../dto/summaries/reportsListSummaryDto';
import type { SchedulingListSummaryDto } from '../dto/summaries/schedulingListSummaryDto';
import type { WorkOrderListSummaryDto } from '../dto/summaries/workOrderListSummary';
import { UserActionRecordDto } from '../dto/records/userActionRecordDto';
import { IntegrationListSummaryDto } from '../dto/summaries/integrationListSummaryDto';
 




class UserService {
  public async create(createUserInput: CreateOrUpdateUserInput) {
    let result = await http.post('api/services/app/User/Create', createUserInput);
    return result.data.result;
  }

  public async update(updateUserInput: UpdateUserInput) {
    let result = await http.put('api/services/app/User/Update', updateUserInput);
    return result.data.result;
  }

  public async delete(entityDto: EntityDto) {
    let result = await http.delete('api/services/app/User/Delete', { params: entityDto });
    return result.data;
  }

  public async getRoles() {
    let result = await http.get('api/services/app/User/GetRoles');
    return result.data.result.items;
  }

  public async changePassword(changePasswordInput: ChangePasswordInput) {
    let result = await http.post('api/services/app/User/ChangePassword', changePasswordInput);
    return result.data;
  }

  public async changeLanguage(changeLanguageInput: ChangeLanguagaInput) {
    let result = await http.post('api/services/app/User/ChangeLanguage', changeLanguageInput);
    return result.data;
  }

  public async resetPassword(resetPasswordInput: ResetPasswordInput) {
    let result = await http.post('api/services/app/User/ResetPassword', resetPasswordInput);
    return result.data;
  }

  public async get(entityDto: EntityDto): Promise<CreateOrUpdateUserInput> {
    let result = await http.get('api/services/app/User/Get', { params: entityDto });
    return result.data.result;
  }

  public async getAll(pagedFilterAndSortedRequest: PagedUserResultRequestDto): Promise<PagedResultDto<GetAllUserOutput>> {
    //console.warn('Starting User Summary: ' + dayjs(new Date()).toString());
    //console.warn(JSON.stringify(pagedFilterAndSortedRequest))
    

    let result = await http.get('api/services/app/User/GetAll', { params: pagedFilterAndSortedRequest });
    //console.warn('Got User Summary: ' + dayjs(new Date()).toString());
    return result.data.result;
  }

  //------------------------------------------------------------------

  public async uploadImage(file: FormData): Promise<FileUpload> {
    let getResult = await http.post('api/services/app/User/UploadFile', file);
    return getResult.data.result;
  }

  public async getImage(id: number): Promise<FileUpload> {
    let getResult = await http.get('api/services/app/User/GetFile?id=' + id);

    return getResult.data.result;
  }

  public async getFiles(id: number, type: number): Promise<FileUpload[]> {
    let getFilesResult = await http.get('api/services/app/User/GetEntityFiles?id=' + id + '&type=' + type);
    return getFilesResult.data.result;
  }

  public async commitEntityFiles(input: EntityCommitContainer): Promise<boolean> {
    let getResult = await http.post('api/services/app/User/CommitEntityFiles', input);
    return getResult.data.result;
  }

  //------------------------------------------------------------------

  public async getNotes(askDto: UserAskDto): Promise<SummaryReturnDto<UserListSummaryDto, EntitySummaryDto, TypeSummaryDto, TemplateSummaryDto, StateSummaryDto, OptionSummaryDto, ItemSummaryDto, NoteSummaryDto, NoteRecordSummaryDto>> {
    let getRecordsResult = await http.get('api/services/app/User/GetNotes', { params: askDto });
    return getRecordsResult.data.result;
  }

  public async addNotes(askDto: CreateDto<EntityDto, ItemDto, OptionDto, RecordDto, StateDto, TypeDto, TemplateDto, NoteDto, NoteRecordDto, TemplateRecordDto>): Promise<ReturnDto<EntityDto, ItemDto, OptionDto, RecordDto, StateDto, TypeDto, TemplateDto, NoteDto, NoteRecordDto, TemplateRecordDto>> {

    let getRecordsResult = await http.post('api/services/app/User/AddNotes', askDto);
    return getRecordsResult.data.result;
  }

  public async deleteNotes(askDto: CreateDto<EntityDto, ItemDto, OptionDto, RecordDto, StateDto, TypeDto, TemplateDto, NoteDto, NoteRecordDto, TemplateRecordDto>): Promise<ReturnDto<EntityDto, ItemDto, OptionDto, RecordDto, StateDto, TypeDto, TemplateDto, NoteDto, NoteRecordDto, TemplateRecordDto>> {
    let getRecordsResult = await http.post('api/services/app/User/DeleteNotes', askDto);
    return getRecordsResult.data.result;
  }

  public async getSummaryView(askDto: PeopleAskDto): Promise<PeopleSummaryReturnDto<PersonListSummaryDto, TeamListSummaryDto, UserListSummaryDto, PeopleEntitySummaryDto, PeopleTypeSummaryDto, PeopleTemplateSummaryDto, PeopleStateSummaryDto, PeopleOptionSummaryDto, PeopleItemSummaryDto, NoteSummaryDto, NoteRecordSummaryDto, InfoHubArticleSummaryDto, CommunicationListSummaryDto, InventoryListSummaryDto, MenuListSummaryDto, PaymentsListSummaryDto, ReportsListSummaryDto, SchedulingListSummaryDto, WorkOrderListSummaryDto, IntegrationListSummaryDto,  UserActionRecordDto>> {
    let getSummaryViewResult = await http.get('api/services/app/Person/GetSummary', { params: askDto });
    return getSummaryViewResult.data.result;
}

public async updateSignatures(askDto: PeopleAskDto): Promise<string> {
 //console.warn(JSON.stringify(askDto))
  let signatureResult = await http.post('api/services/app/User/AddSignatures', askDto );
  return signatureResult.data.result;
}
    
}

export default new UserService();
